import type { TransFormedCardPaymentMethod } from '../../../models';

const BANCONTACT_CARD_TYPE_ID = 66;

export const shouldShowBancontactCardLogo = (
  creditCards?: TransFormedCardPaymentMethod['creditCards'],
) => Boolean(creditCards?.some((card) => card?.id === BANCONTACT_CARD_TYPE_ID));
